import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '../../Models/User';

export interface IUserLoggedState {
  user: IUser | null;
  sidebarOpen: boolean;
  drawerWidth: number;
}

const initialState: IUserLoggedState = {
  user: null,
  sidebarOpen: false,
  drawerWidth: 271
};

export const loggedUserSlice = createSlice({
  initialState,
  name: 'loggedUserSlice',
  reducers: {
    logout: () => initialState,
    setUserLogged: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    toggleSidebar: (state, action: PayloadAction<void>) => {
      let newSidebarState = current(state).sidebarOpen;
      state.sidebarOpen = !newSidebarState;
      
      state.drawerWidth = newSidebarState === true ? 0 : 271;
    },
  },
});

export default loggedUserSlice.reducer;

export const { logout, setUserLogged, toggleSidebar } = loggedUserSlice.actions;
